import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { LigneFinancement } from '../../model/ligneFinancement/ligneFinancement';

@Injectable({
  providedIn: "root"
})
export class LigneFinancementService {
  constructor(private _restClientService: RestClientService) {}

  getAllLigneFinancement() {
    return this._restClientService.load<LigneFinancement[]>(
      "ligne-financement/find-all"
    );
  }

  getById(id) {
    return this._restClientService.load<LigneFinancement>(
      "ligne-financement/find-by-id//" + id
    );
  }

  add(ligneFinancement) {
    return this._restClientService.save<LigneFinancement>(
      "ligne-financement/add",
      ligneFinancement
    );
  }

  update(ligneFinancement) {
    return this._restClientService.put<LigneFinancement>(
      `ligne-financement/update`,
      ligneFinancement
    );
  }

  delete(id) {
    return this._restClientService.delete<any>(
      "ligne-financement/delete/" + id
    );
  }
}
